module.exports = __webpack_public_path__ + "static/media/bayrhuu.17b9c9a6.png";